import React, { useState, useRef, useEffect } from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import Image from '~components/Image'
import { breakpoints } from '~styles/global'
import Video from '~components/Video'
import { isMobile, browserName } from 'react-device-detect'

const ProductTile = ({ name, image, link, gif, price, className, type, video, available }) => {

	console.log(browserName)

  const { mobile } = breakpoints
  const [hovering, setHovering] = useState(false)
	const videoRef = useRef()

	useEffect(() => {
		if(hovering && videoRef) videoRef?.current?.play()
		else videoRef?.current?.pause()
	}, [hovering])

  return (
    <Link
      to={link}
      className={className}
      onMouseEnter={() => window.innerWidth > 1024 ? setHovering(true) : null}
      onMouseLeave={() => setHovering(false)}
      css={css`
        margin-bottom: 20px;
        grid-column: span 4;
        cursor: pointer;
        ${mobile} {
            grid-column: span 12;
        }
      `}
    >
      <div css={css`position: relative;`}>
        <Image asset={image} aspectRatio={1} width={500} />
				{!isMobile && browserName !== 'Safari' &&
					<video ref={videoRef} playsInline muted loop style={{width: '100%'}} css={css`
						position: absolute;
						top: 0;
						bottom: 0;
						right: 0;
						left: 0;
						transition: opacity 0.3s;
						width: 100%;
						z-index: 5;
					`}>
						<source src={video?.asset.url} />
					</video>
				}
				{/* <Video src={video?.asset.url} css={css`
						position: absolute;
						top: 0;
						bottom: 0;
						right: 0;
						left: 0;
						transition: opacity 0.3s;
						width: 100%;
						z-index: 5;
						video{
							object-fit: cover;
						}
				`}/>	 */}
      </div>

      <div css={css`
          padding: 20px;
          display: grid;
          grid-template-columns: auto auto;
      `}>
          <h3 css={css`
              justify-self: start;
          `}>
              {name}
          </h3>
          <h3 css={css`
              justify-self: end;
              color: var(--gold);
              transition: opacity 0.3s;
              opacity: ${ hovering ? '1' : '0' };
              ${mobile} {
                  opacity: 1;
              }
          `}>
              {available ? '$' + price : 'Sold out'}
          </h3>
      </div>
    </Link>
  )
}

ProductTile.propTypes = {
    name: PropTypes.string.isRequired,
    image: PropTypes.object,
    gif: PropTypes.object,
    price: PropTypes.number.isRequired,
    link: PropTypes.string.isRequired,
}

ProductTile.defaultProps = {
    name: 'Product Name',
    price: 14.99,
    hovered: false,
    link: '/',
}

export default ProductTile
